import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@quizzach/contexts';
import { IcCheck } from '@quizzach/assets';
import { CkRow } from '@quizzach/styles';
import { PaymentCardOptions } from './PaymentCardOptions';

// Method ids double as the ?method= query param on the Corvus payment handoff.
const corvusPaymentMethods = [
	{
		id: 'applepay',
		labelKey: 'cart.payment.applePay',
		icon: '/card-icons/payment_applepay.svg',
		iconWidth: 72,
	},
	{
		id: 'googlepay',
		labelKey: 'cart.payment.googlePay',
		icon: '/card-icons/payment_googlepay.svg',
		iconWidth: 72,
	},
	{
		id: 'card',
		labelKey: 'cart.payment.cardPayment',
		icon: '/card-icons/payment_card.svg',
		iconWidth: 38,
	},
];

export const PaymentOptions = ({
	selectedProvider,
	setSelectedProvider,
	termsConsent,
	setTermsConsent,
	legalConsent,
	setLegalConsent,
}: {
	selectedProvider: string;
	setSelectedProvider: (provider: string) => void;
	termsConsent: boolean;
	setTermsConsent: Dispatch<SetStateAction<boolean>>;
	legalConsent: boolean;
	setLegalConsent: Dispatch<SetStateAction<boolean>>;
}) => {
	const consentsGiven = termsConsent && legalConsent;
	const { profileInfo } = useAuth();
	const { t } = useTranslation();

	return (
		<div style={{ textAlign: 'left' }}>
			{/* card-brand icons lead, right above the consents (founder pick) */}
			<div className='card-logos'>
				<PaymentCardOptions />
			</div>

			<CkRow style={{ marginBottom: '20px' }}>
				<input
					type='checkbox'
					checked={legalConsent}
					onChange={() => setLegalConsent(!legalConsent)}
				/>
				<span className='box'>
					<IcCheck size={14} />
				</span>
				<p>{t('cart.payment.legalConsent')}</p>
			</CkRow>
			<CkRow style={{ marginBottom: '20px' }}>
				<input
					type='checkbox'
					checked={termsConsent}
					onChange={() => setTermsConsent(!termsConsent)}
				/>
				<span className='box'>
					<IcCheck size={14} />
				</span>
				<p>
					{t('cart.payment.termsConsent')}
					<br />
					<i>
						{t('cart.payment.termsNote')}{' '}
						<a href='/info' target='_blank' rel='noopener noreferrer'>
							{t('cart.payment.termsNoteLink')}
						</a>
					</i>
				</p>
			</CkRow>

			<div className='pt' style={{ marginTop: '10px' }}>
				{t('cart.payment.chooseMethod')}
			</div>
			<div className='providers'>
				{corvusPaymentMethods.map((method) => (
					<button
						key={method.id}
						type='button'
						className={`provider ${
							selectedProvider === method.id ? 'on' : ''
						}`}
						disabled={!consentsGiven}
						onClick={() => consentsGiven && setSelectedProvider(method.id)}
					>
						<img
							src={method.icon}
							alt={t(method.labelKey)}
							width={method.iconWidth}
						/>
						<span className='pv-lbl'>{t(method.labelKey)}</span>
					</button>
				))}
				{profileInfo?.qpay_enabled && (
					<button
						type='button'
						className={`provider ${
							selectedProvider === 'fakepay' ? 'on' : ''
						}`}
						disabled={!consentsGiven}
						onClick={() => consentsGiven && setSelectedProvider('fakepay')}
					>
						<img src={`/provider_fakepay.png`} alt='Q pay' width={64} />
					</button>
				)}
			</div>
		</div>
	);
};
